export default __webpack_public_path__ + "assets/images/8c1c6f68af4cd50341b5650c1c58f946.png";